import { c as _c } from "react/compiler-runtime";
import { translate } from '@openclassrooms/translations';
import { styled } from '@classify/react-core-components/styles';
const List = styled('ul')({
  margin: 0,
  padding: 0,
  width: '100%',
  position: 'absolute',
  zIndex: 99999999,
  top: -300,
  '& li': {
    listStyle: 'none'
  }
});
const Item = styled('a')({
  position: 'absolute',
  left: 0,
  right: 0,
  textAlign: 'center',
  fontSize: 20,
  textDecoration: 'none',
  fontWeight: 'bold',
  backgroundColor: 'rgba(255, 255, 255, 0.9)',
  color: 'black',
  '&:focus, &:hover': {
    padding: 20,
    top: 300,
    color: 'inherit'
  }
});
export default function SearchButton() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = translate("navigation.word.avoidance_links");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <li><Item href="#mainContent">{translate("skip_link.label.content")}</Item></li>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <li><Item href="#footerChangeLanguage">{translate("skip_link.label.language")}</Item></li>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <nav aria-label={t0}><List>{t1}{t2}<li><Item href="#main-search">{translate("skip_link.label.search")}</Item></li></List></nav>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}